function loadScript(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;

  script.onload = function () {
    if (callback) callback();
  };

  document.head.appendChild(script);
}
export default loadScript;
